var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-footer',[_c('span',{staticClass:"indigo--text font-weight-bold"},[_vm._v("Perumda Pembangunan Sarana Jaya")])])}
var staticRenderFns = []

export { render, staticRenderFns }